import React from "react";
import SymptomSearch from "./symptomSearch";
import TypeOfCare from "./typeOfCare";

const ComponentSplitting = ({ content }) => {
  const { symptomSearch, typeOfCare } = content;
  return (
    <div id="ComponentSplitting">
      <div className="wrap">
        <div className="columnOne">{symptomSearch && <SymptomSearch content={symptomSearch} />}</div>
        <div className="columnTwo">{typeOfCare && <TypeOfCare content={typeOfCare} />}</div>
      </div>
    </div>
  );
};

export default ComponentSplitting;
